import { getApiBaseUrl, safeFetch } from './apiConfig';

const API_URL = 'https://us-central1-nexawave-4d18a.cloudfunctions.net'; // Live
// const API_URL = 'http://127.0.0.1:5001/nexawave-4d18a/us-central1'; // Local emulator

/**
 * Get estimated delivery date from Shiprocket via Firebase Function
 * @param {string} pincode - Destination pincode
 * @returns {Promise<Object>} - Delivery date info
 */
export const getEstimatedDeliveryDate = async (pincode) => {
  if (!pincode) return null;
  
  try {
    const url = `${getApiBaseUrl('getDeliveryDate')}?delivery_pincode=${pincode}`;
    const response = await safeFetch(url);
    return await response.json();
  } catch (error) {
    // Detailed error logging is handled by safeFetch
    return null;
  }
};

export const createShiprocketOrder = async (orderData) => {
  try {
    const response = await safeFetch(getApiBaseUrl('createOrder'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(orderData),
    });

    return await response.json();
  } catch (error) {
    console.error("Shiprocket order creation failed:", error);
    throw error;
  }
};

export const trackShipment = async (shipmentId) => {
  try {
    // 1. Authenticate with Shiprocket (Frontend testing only)
    const authRes = await fetch('https://apiv2.shiprocket.in/v1/external/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: 'syed.taha04@hotmail.com',
        password: 'wUr7HKDzD8yLSValx0W!KM51ziRZVaCN'
      })
    });
    
    if (!authRes.ok) throw new Error('Shiprocket frontend auth failed');
    const authData = await authRes.json();
    const token = authData.token;

    // 2. Fetch tracking details directly
    const trackRes = await fetch(`https://apiv2.shiprocket.in/v1/external/courier/track/shipment/${shipmentId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!trackRes.ok) throw new Error('Failed to track shipment directly');
    return trackRes.json();
  } catch (error) {
    console.error('Frontend Tracking bypass error:', error);
    throw error;
  }
};